<template>
	<div class="seller-entry">
		<div class="btnbox">
			<el-button size="small" @click="goList">返回云仓列表</el-button>
			<el-button size="small" @click="goRecord">入仓记录</el-button>
		</div>
		<div class="card" v-if="warehouse.id">
			<div class="card-title">目标云仓</div>
			<div class="info-grid">
				<div><span>名称</span>{{ warehouse.name }}</div>
				<div><span>地址</span>{{ warehouse.address }}</div>
				<div><span>可用额度</span>¥{{ fenToYuan(warehouse.available_amount) }}</div>
			</div>
			<p class="tip">提交即扣减渠道库存，仅审核拒绝时自动回补。单批最多 50 行。折扣口径与渠道管理一致，5 表示 5 折。试算为供货价合计；仓东预冻结按综合拿货价由后端计算。</p>
		</div>

		<div class="card">
			<div class="card-title">添加入仓明细</div>
			<el-form :inline="true" size="small">
				<el-form-item label="渠道">
					<el-select v-model="shop_id" placeholder="请选择渠道" filterable @change="onShopChange">
						<el-option :label="v.name" :value="v.id" v-for="(v, k) in shops" :key="v.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="款号">
					<el-input v-model="keyword" placeholder="选填，可留空查看有库存款号" :disabled="!shop_id" @keyup.enter.native="onSearchProduct"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :disabled="!shop_id" @click="onSearchProduct">查询商品</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="productOptions" style="width: 100%" border v-if="shop_id" v-loading="productLoading">
				<el-table-column prop="product_style_number" label="款号" align="center" header-align="center"></el-table-column>
				<el-table-column prop="product_brand" label="品牌" align="center" header-align="center"></el-table-column>
				<el-table-column prop="discount" label="渠道折扣" align="center" header-align="center"></el-table-column>
				<el-table-column prop="stock" label="库存合计" align="center" header-align="center"></el-table-column>
				<el-table-column label="操作" align="center" header-align="center" width="90px">
					<template slot-scope="scope">
						<div class="operation_i">
							<span @click="addProduct(scope.row)">添加</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="product-pager" v-if="productTotal > 0">
				<el-pagination background layout="prev, pager, next, total" :current-page="productPage"
					:page-size="productPageSize" :total="productTotal" @current-change="handleProductPageChange">
				</el-pagination>
			</div>
		</div>

		<div class="card">
			<div class="card-title-row">
				<div class="card-title">入仓明细</div>
				<div class="item-summary" v-if="items.length">
					{{ items.length }} 款 / 已填 {{ filledQty }} 件 / 还可再加 {{ remainLines }} 行
				</div>
			</div>
			<div class="empty-items" v-if="!items.length">请先查询并添加商品</div>
			<div class="item-scroll" v-else>
				<el-table :data="items" border size="mini" style="width: 100%">
					<el-table-column prop="style_number" label="款号" width="130" align="center" header-align="center"></el-table-column>
					<el-table-column label="折扣" width="120" align="center" header-align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.discount" size="mini" placeholder="如 5"></el-input>
							<div class="min-tip" v-if="scope.row.min_discount > 0 && Number(scope.row.discount) > Number(scope.row.min_discount)">
								历史最低 {{ scope.row.min_discount }} 折
							</div>
						</template>
					</el-table-column>
					<el-table-column label="供货价" width="100" align="center" header-align="center">
						<template slot-scope="scope">¥{{ fenToYuan(rowCost(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="小计" width="100" align="center" header-align="center">
						<template slot-scope="scope">¥{{ fenToYuan(rowValue(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="尺码（库存）" min-width="280" align="left" header-align="center">
						<template slot-scope="scope">
							<div class="size-inline">
								<div class="size-chip" v-for="size in scope.row.sizes" :key="size.id">
									<span class="size-name">{{ size.size }}</span>
									<span class="size-stock">{{ size.stock }}</span>
									<el-input-number v-model="size.quantity" :min="0" :max="size.stock" :precision="0" :controls="false" size="mini"></el-input-number>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="70" align="center" header-align="center" fixed="right">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="removeRow(scope.$index)">删除</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="item-footer">
				<div class="total">入仓价值试算：¥{{ fenToYuan(totalFen) }}</div>
				<div class="btndiv">
					<el-button type="primary" :loading="submitting" @click="onsub">提交申请</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg } from './money.js'

	export default {
		name: 'SellerWarehouseEntry',
		data() {
			return {
				warehouse: {},
				shops: [],
				shop_id: '',
				keyword: '',
				productSource: [],
				productOptions: [],
				productPage: 1,
				productPageSize: 20,
				productTotal: 0,
				productLoading: false,
				items: [],
				submitting: false
			}
		},
		computed: {
			warehouseId() {
				return this.$route.query.warehouse_id
			},
			totalFen() {
				var self = this
				return this.items.reduce(function(sum, row) {
					return sum + self.rowValue(row)
				}, 0)
			},
			filledQty() {
				return this.items.reduce(function(sum, row) {
					return sum + (row.sizes || []).reduce(function(qty, size) {
						return qty + Number(size.quantity || 0)
					}, 0)
				}, 0)
			},
			remainLines() {
				return Math.max(0, 50 - this.sizeLineCount())
			}
		},
		mounted() {
			if (!this.warehouseId) {
				this.$message.warning('请先选择云仓')
				this.goList()
				return
			}
			this.loadWarehouse()
			this.loadShops()
		},
		methods: {
			fenToYuan: fenToYuan,
			goList() {
				this.$router.push('/seller/warehouse/index')
			},
			goRecord() {
				this.$router.push('/seller/warehouse/record')
			},
			rowCost(row) {
				var discount = parseFloat(row.discount)
				if (!row.product_price_fen || isNaN(discount)) {
					return 0
				}
				return Math.round(Number(row.product_price_fen) * discount / 10)
			},
			rowValue(row) {
				var cost = this.rowCost(row)
				var qty = (row.sizes || []).reduce(function(sum, size) {
					return sum + Number(size.quantity || 0)
				}, 0)
				return cost * qty
			},
			sizeLineCount() {
				return this.items.reduce(function(sum, row) {
					return sum + ((row.sizes && row.sizes.length) || 0)
				}, 0)
			},
			loadWarehouse() {
				this.$axios.get('api/cloud_warehouse/warehouse_list', {
					params: { page: 1, limit: 100 }
				}).then(res => {
					if (res.data.code === 0) {
						var list = (res.data.data && res.data.data.list) || []
						this.warehouse = list.filter(v => String(v.id) === String(this.warehouseId))[0] || {}
						if (!this.warehouse.id) {
							this.$message.error('云仓不存在或未开通')
							this.goList()
						}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			loadShops() {
				this.$axios.post('api/user/shop_list', {
					code: '',
					name: '',
					state: 2,
					page: 1,
					limit: 99999
				}).then(res => {
					if (res.data.code === 0) {
						this.shops = (res.data.data && res.data.data.list) || []
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			hasStock(item) {
				return Number(item && item.stock) > 0
			},
			onShopChange() {
				this.items = []
				this.productSource = []
				this.productOptions = []
				this.keyword = ''
				this.productPage = 1
				this.productTotal = 0
				if (this.shop_id) {
					this.loadShopProducts()
				}
			},
			onSearchProduct() {
				this.productPage = 1
				this.applyProductView(true)
			},
			handleProductPageChange(page) {
				this.productPage = page
				this.applyProductView(false)
			},
			filteredProductSource() {
				var keyword = String(this.keyword || '').trim().toLowerCase()
				var list = this.productSource
				if (!keyword) {
					return list
				}
				return list.filter(function(item) {
					return String(item.product_style_number || '').toLowerCase().indexOf(keyword) !== -1
				})
			},
			applyProductView(showEmptyTip) {
				var list = this.filteredProductSource()
				this.productTotal = list.length
				var start = (this.productPage - 1) * this.productPageSize
				this.productOptions = list.slice(start, start + this.productPageSize)
				if (showEmptyTip && !this.productOptions.length) {
					this.$message.warning(this.keyword ? '未找到有库存的商品' : '该渠道暂无有库存商品')
				}
			},
			loadShopProducts() {
				if (!this.shop_id) {
					this.$message.warning('请选择渠道')
					return
				}
				this.productLoading = true
				this.$axios.post('api/user/shop_discount_list', {
					shop_id: this.shop_id,
					style_number: '',
					page: 1,
					limit: 99999
				}).then(res => {
					this.productLoading = false
					if (res.data.code === 0) {
						var list = (res.data.data && res.data.data.list) || []
						this.productSource = list.filter(this.hasStock)
						this.applyProductView(true)
					} else {
						this.productSource = []
						this.productOptions = []
						this.productTotal = 0
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.productLoading = false
					console.log(err)
				})
			},
			addProduct(product) {
				var productId = product.product_id
				var exists = this.items.some(function(row) {
					return row.product_id == productId
				})
				if (exists) {
					this.$message.warning('该商品已添加，请直接在明细里填写各尺码数量')
					return
				}
				this.$axios.post('api/user/compare_price', {
					product_id: productId,
					from: 1,
					page: 1,
					limit: 50
				}).then(res => {
					if (res.data.code !== 0) {
						this.$message.error(apiMsg(res))
						return
					}
					var sizes = (res.data.data && res.data.data.sizes) || []
					var shopRow = ((res.data.data && res.data.data.list) || []).filter(v => v.shop_id == this.shop_id)[0]
					var sizeList = sizes.map(function(size) {
						return {
							id: size.id,
							size: size.size,
							size_ch: size.size_ch,
							stock: shopRow ? Number(shopRow['size_' + size.id] || 0) : 0,
							quantity: 0
						}
					}).filter(function(size) {
						return size.stock > 0
					})
					if (!sizeList.length) {
						this.$message.warning('该商品在当前渠道没有可售库存')
						return
					}
					if (this.sizeLineCount() + sizeList.length > 50) {
						this.$message.warning('单次最多提交50条明细')
						return
					}
					var row = {
						product_id: productId,
						style_number: product.product_style_number,
						sizes: sizeList,
						discount: product.discount,
						min_discount: 0,
						product_price_fen: 0
					}
					this.items.push(row)
					this.loadReference(row)
				}).catch(err => {
					console.log(err)
				})
			},
			loadReference(row) {
				this.$axios.get('api/cloud_warehouse/discount_reference', {
					params: { product_id: row.product_id }
				}).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						row.min_discount = data.min_discount || 0
						row.product_price_fen = data.product_price || 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			removeRow(index) {
				this.items.splice(index, 1)
			},
			onsub() {
				if (!this.warehouse.id) {
					this.$message.warning('请选择云仓')
					return
				}
				if (!this.shop_id) {
					this.$message.warning('请选择渠道')
					return
				}
				if (!this.items.length) {
					this.$message.warning('入仓明细不能为空')
					return
				}
				var payload = []
				for (var i = 0; i < this.items.length; i++) {
					var row = this.items[i]
					var discount = parseFloat(row.discount)
					if (isNaN(discount) || discount < 0 || discount > 10) {
						this.$message.warning('折扣范围为0-10（如5表示5折）')
						return
					}
					var sizes = row.sizes || []
					for (var j = 0; j < sizes.length; j++) {
						var quantity = Number(sizes[j].quantity || 0)
						if (quantity <= 0) {
							continue
						}
						payload.push({
							product_id: Number(row.product_id),
							size_id: Number(sizes[j].id),
							quantity: quantity,
							discount: discount
						})
					}
				}
				if (!payload.length) {
					this.$message.warning('请至少填写一个尺码的入仓数量')
					return
				}
				if (payload.length > 50) {
					this.$message.warning('单次最多提交50条明细')
					return
				}
				this.submitting = true
				this.$axios.post('api/cloud_warehouse/entry_apply', {
					warehouse_id: this.warehouse.id,
					shop_id: this.shop_id,
					items: JSON.stringify(payload)
				}).then(res => {
					this.submitting = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						if (data.tip) {
							this.$message.warning(data.tip)
						}
						this.$message.success('提交成功，已扣减渠道库存')
						this.$router.push({
							path: '/seller/warehouse/record',
							query: data.batch_id ? { batch_id: data.batch_id } : {}
						})
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.submitting = false
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-entry {
		padding-bottom: 20px;
	}

	.card {
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		padding: 16px;
		margin-bottom: 16px;
	}

	.card-title {
		font-weight: 600;
		margin-bottom: 12px;
	}

	.info-grid {
		display: flex;
		flex-wrap: wrap;
		div {
			width: 33%;
			line-height: 28px;
			span {
				display: inline-block;
				width: 70px;
				color: #909399;
			}
		}
	}

	.tip {
		margin-top: 8px;
		font-size: 12px;
		color: #909399;
	}

	.min-tip {
		margin-top: 4px;
		font-size: 12px;
		color: #E6A23C;
		line-height: 1.2;
	}

	.empty-items {
		color: #909399;
		padding: 12px 0;
	}

	.product-pager {
		margin-top: 12px;
		text-align: right;
	}

	.card-title-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 12px;
		.card-title {
			margin-bottom: 0;
		}
	}

	.item-summary {
		font-size: 12px;
		color: #909399;
	}

	.item-scroll {
		max-height: 52vh;
		overflow: auto;
	}

	.item-footer {
		margin-top: 12px;
	}

	.size-inline {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	.size-chip {
		display: flex;
		align-items: center;
		margin: 2px 12px 2px 0;
		.size-name {
			font-weight: 600;
			margin-right: 4px;
		}
		.size-stock {
			font-size: 12px;
			color: #909399;
			margin-right: 4px;
		}
	}

	.total {
		margin: 8px 0 12px;
		font-weight: 600;
	}

	.btndiv {
		display: flex;
		justify-content: center;
	}

	/deep/ .size-chip .el-input-number {
		width: 52px;
	}

	/deep/ .size-chip .el-input__inner {
		padding: 0 4px;
		height: 24px;
		line-height: 24px;
		text-align: center;
	}

	/deep/ .item-scroll .el-input--mini .el-input__inner {
		height: 24px;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/entry.vue